import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-ui-page-filters-wrapper',
  templateUrl: './page-filters-wrapper.component.html',
  host: { class: 'tw:flex tw:flex-wrap tw:items-center tw:gap-2.5' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageFiltersWrapperUIComponent {}
